<app-history-list [historyData]="historyData$ | async" [entityType]="entityType" [loading]="loading"></app-history-list>
